export function formatDate(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  const date = typeof value === "number" ? new Date(value) : new Date(normalizeSqlDate(value));
  if (Number.isNaN(date.getTime())) {
    return "—";
  }
  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "short",
    timeStyle: "medium",
  }).format(date);
}

export function formatRelative(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") {
    return "Nunca";
  }
  const date = typeof value === "number" ? new Date(value) : new Date(normalizeSqlDate(value));
  const diffSeconds = Math.round((date.getTime() - Date.now()) / 1000);
  if (!Number.isFinite(diffSeconds)) {
    return "Nunca";
  }
  const formatter = new Intl.RelativeTimeFormat("pt-BR", { numeric: "auto" });
  if (Math.abs(diffSeconds) < 60) {
    return formatter.format(diffSeconds, "second");
  }
  const minutes = Math.round(diffSeconds / 60);
  if (Math.abs(minutes) < 60) {
    return formatter.format(minutes, "minute");
  }
  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) {
    return formatter.format(hours, "hour");
  }
  return formatter.format(Math.round(hours / 24), "day");
}

export function formatBytes(value: number): string {
  if (!Number.isFinite(value) || value < 0) {
    return "—";
  }
  return new Intl.NumberFormat("pt-BR", {
    style: "unit",
    unit: value >= 1_000_000 ? "megabyte" : "kilobyte",
    unitDisplay: "short",
    maximumFractionDigits: 1,
  }).format(value >= 1_000_000 ? value / 1_000_000 : value / 1_000);
}

export function formatUptime(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined) {
    return "—";
  }
  const days = Math.floor(seconds / 86_400);
  const hours = Math.floor((seconds % 86_400) / 3_600);
  if (days > 0) {
    return `${days}d ${hours}h`;
  }
  return `${hours}h ${Math.floor((seconds % 3_600) / 60)}min`;
}

export function humanizeAction(value: string): string {
  const labels: Record<string, string> = {
    "admin.bootstrap": "Administrador provisionado",
    "collector.create": "Coletor criado",
    "collector.update": "Coletor atualizado",
    "collector.secret.rotate": "Secret rotacionado",
    "collector.revoke": "Coletor revogado",
    "camera.create": "Câmera criada",
    "camera.update": "Câmera atualizada",
    "camera.disable": "Câmera desativada",
    "destination.activate": "Destino alterado",
    "frame.read_url.issue": "Preview de frame solicitado",
  };
  return labels[value] ?? value;
}

function normalizeSqlDate(value: string): string {
  return /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/u.test(value)
    ? `${value.replace(" ", "T")}Z`
    : value;
}
